import { render } from "./addDealer.vue?vue&type=template&id=35721a8c"
import script from "./addDealer.vue?vue&type=script&lang=js"
export * from "./addDealer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__